import React, { memo } from "react";
import { Marker } from "react-mapbox-gl";

import { palette } from "../../../styles/palette";

const styles = {
  mlMarker: {
    paddingTop: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    pointerEvents: "none",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
  },
  tile: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    boxShadow: "1px 1px",
    borderRadius: "8px",
    backgroundColor: palette.typography.white.solid,
  },
  content: {
    fontSize: "12px",
    fontWeight: "bold",
    padding: "1px 5px",
    border: "1px solid black",
    borderRadius: "8px",
    color: palette.typography.black.solid,
  },
  footer: {
    color: palette.grey,
    fontWeight: 400,
  },
};

export const ManifestLocationLayer = memo(({ map, manifestLocations }) =>
  manifestLocations.map(({ locationCode, name, longitude, latitude }) => {
    return (
      map && (
        <Marker
          style={styles.mlMarker}
          key={`${locationCode} marker`}
          coordinates={[longitude, latitude]}
          anchor={"center"}
          draggable={false}
        >
          <div style={styles.container}>
            <div style={styles.tile}>
              <div style={styles.content}>{locationCode}</div>
            </div>
          </div>
          <div style={styles.footer}>{name}</div>
        </Marker>
      )
    );
  })
);
